<template>
	<div class="automation-entry-wrapper">
	<div class="entry panel-item automation-entry" style="z-index: 2">

		<a @click.prevent="$router.push('/automations/'+automation.id)" class="list-item-link">

			<div class="flex-none __img">
				<inline-svg :src="require('@/assets/img/logo.svg')" />
			</div>

			<div class="__caption">
				<div class="__name">{{ automation.name }}</div>
				<span>{{ date(automation.updated_at).diff }}</span>
			</div>
		</a>

		<div class="layout-row flex-center flex-none __btns">
			<v-switch class="__switch" v-model="automation.is_active" :value="automation.is_active"
			          :label="automation.is_active?'Active':'Inactive'" right :loading="saving" @change="saveChangesToAPI"/>


<!--			<a @click="pinnFunnel(funnel)"-->
<!--			   v-tippy="{theme:'small-black'}" :content="funnel.pinned?'Unpin':'Pin'"-->
<!--			   :class="{'panel_item_btn pinn_btn':true, 'active':funnel.pinned}">-->
<!--				<v-spinner v-if="pinning" />-->
<!--				<inline-svg v-else :src="require('@/assets/img/pinn_icon.svg')"/>-->
<!--			</a>-->
			<a @click="clone"
			   v-tippy="{theme:'small-black'}" content="Clone automation" class="copy_btn" :class="{'disabled':!is('automations')}">
				<v-spinner v-if="cloning" />
				<inline-svg v-else :src="require('@/assets/img/copy.svg')"/>
			</a>
			<portal to="popup">
<!--				<clone-funnel-popup v-if="cloneOpen" @close="cloneOpen=false"-->
<!--				                     :funnel="funnel" />-->
			</portal>
			<a @click="" v-tippy="{theme:'small-black'}" content="Delete automation" class="delete_btn"
			   :class="{'disabled':!is('automations')}" @click="deleteAutomationOpen=true">
				<inline-svg :src="require('@/assets/img/trash.svg')"/>
			</a>
		</div>

	</div>
	<portal to="popup" v-if="deleteAutomationOpen">
		<delete-automation-popup :automation="automation" @done="$emit('deleted',automation)" @close="deleteAutomationOpen=false" />
	</portal>
	</div>
</template>

<script>
import API from "@/api";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";
import VButton from "@/components/base/v-button";
import Loading from "@/components/Loading";
import {is} from "@/helpers/roles";
import VSwitch from "@/components/base/v-switch";
import DeleteAutomationPopup from "./delete-automation-popup";
import VSpinner from "@/components/base/v-spinner";

TimeAgo.addLocale(en);
const timeAgo = new TimeAgo("en-US");

export default {
	name: "automation-entry",
	components: {
		VSpinner,
		DeleteAutomationPopup,
		VSwitch, Loading, VButton},
	props: ['automation'],
	mixins: [API],
	data() {
		return {
			saving:false,
			cloning:false,
			deleteAutomationOpen:false,
		}
	},
	computed: {
	},
	methods: {
		is(role){
			return is(role)
		},
		date(string) {
			var date = new Date(string);
			var monthArr = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
			var month = monthArr[date.getMonth()];
			var day = date.getDate();
			var hours = date.getHours();
			var minutes = date.getMinutes();

			var format = `${month} ${day} ${hours}:${minutes}`;
			var diff = timeAgo.format(date);
			//Feb 26 16:58
			return {format, diff};
		},
		async saveChangesToAPI() {
			try {
				this.saving = true;

				await this.api.globalAutomations.update(this.automation.id, this.automation);

			} catch (e) {
				this.$error(e)
			} finally {
				this.saving = false;
			}
		},
		async clone() {
			try {
				this.cloning = true;
				let res = await this.api.globalAutomations.create(this.automation.id, this.automation.access_key);
				if (!res.error)
					this.$emit('cloned', res)
			} catch (e) {
				this.$error(e)
			} finally {
				this.cloning = false;
			}
		},
	}
};
</script>

<style lang="scss" scoped>
.automation-entry {
.__img {
	width: 40px;
	height: 40px;
	display: flex;
	margin-right: 15px;
	color: #6b6c70;
	align-items: center;
	svg {
		width: 28px;
		height: 28px;
	}
}

	.__caption {
		display: flex;
		flex-direction: column;
		flex: 1;
		gap: 5px;

		.__name {
			font-weight: 600;
			font-size: 16px;
		}
	}
	.__btns {
		display: flex;
		flex-direction: row;
		flex: 0;
		align-items: center;
		gap: 15px;

		.__switch:hover {
			background: $dark-hover-light-blue;
			border-radius: 8px;
		}
		a {
			border-radius: 8px;
			width: 36px;
			height: 36px;
			display: flex;
			justify-content: center;
			flex-direction: column;
			align-items: center;
			position: relative;
			&:hover {
				background: $dark-hover-light-blue;
				color: $darker-grey;
			}
			&.delete_btn {
				color: $light-red;
				opacity: 0.7;
				&:hover {
					color: $light-red;
					opacity: 1;
				}
			}
		}
	}
}

.automation-entry-wrapper {


}
</style>
